import { Link, useLocation } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { BUSINESS } from "../config/business";

// Sticky mobile CTA — hidden on desktop. Shown on every page.
export default function StickyMobileCTA() {
  const { pathname } = useLocation();
  const isContact = pathname === "/contact";

  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#7A2D2F] text-white border-t border-[#0D0D0E]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="sticky-mobile-cta"
    >
      <div className="grid grid-cols-2 divide-x divide-[#0D0D0E]">
        <a
          href={`tel:${BUSINESS.phone}`}
          className="flex items-center justify-center gap-2 py-3.5 text-[14px] font-semibold active:bg-[#0D0D0E]"
          data-testid="sticky-call-btn"
        >
          <Phone size={16} />
          Call now
        </a>
        {isContact ? (
          <a
            href={`mailto:${BUSINESS.email}`}
            className="flex items-center justify-center gap-2 py-3.5 text-[14px] font-semibold bg-[#C9A876] active:bg-[#5E2023]"
            data-testid="sticky-email-btn"
          >
            <FileText size={16} />
            Email us
          </a>
        ) : (
          <Link
            to="/contact"
            className="flex items-center justify-center gap-2 py-3.5 text-[14px] font-semibold bg-[#C9A876] active:bg-[#5E2023]"
            data-testid="sticky-quote-btn"
          >
            <FileText size={16} />
            Request quote
          </Link>
        )}
      </div>
    </div>
  );
}
